import { getQueue, logWorkspace, serviceState } from '../..';
import getQueues from '../../getQueues';
import * as Telecom from '@servicetitan/telecom-rtcs-client';

async function handleQueueStatus(event: Telecom.QueueStatusEvent) {
  const queue = getQueue(event.queueId);

  logWorkspace('service:queue:status:' + queue?.name, event);

  if (!queue) {
    serviceState.queues = await getQueues();
    return;
  }

  queue.status.abandonedSessions = event.stats.abandonedSessions;
  queue.status.activeSessionCount = event.stats.activeSessions;
  queue.status.averageWait = event.stats.averageWaitMs;
  queue.status.longestWait = event.stats.longestWaitMs;
  queue.status.missedSessions = event.stats.missedSessions;
  queue.status.recipientCount = event.stats.agents;
  queue.status.totalSessions = event.stats.totalSessions;
  queue.status.activeRecipientCount = event.activeAgents;
  queue.status.availableRecipientCount = event.availableAgents;

  queue.memberIds = event.agentIds;

  return;
}

export default handleQueueStatus;
